import TenantContextProvider from './tenant/TenantContext';
import SecurityContextProvider from './security/SecurityContext';
import AppRoutes from './AppRoutes';
import { MessagesContextProvider } from './messages/MessagesContext';
import { useEffect } from 'react';
import { APP_TITLE } from './config/config';
import PaymentCartContextProvider from 'pages/payment-cart/PaymentCartContext';
//import "./assets/css/demo.css";

function App() {
  useEffect(() => {
    document.title = APP_TITLE;
  });
  return (
    <div className="App">
      <MessagesContextProvider>
        <TenantContextProvider>
          <SecurityContextProvider>
            <PaymentCartContextProvider>
              <AppRoutes />
            </PaymentCartContextProvider>
          </SecurityContextProvider>
        </TenantContextProvider>
      </MessagesContextProvider>
    </div>
  );
}

export default App;
